var render, staticRenderFns
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e75c60e')) {
      api.createRecord('2e75c60e', component.options)
    } else {
      api.reload('2e75c60e', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/views/auth/Logout.vue"
export default component.exports